const getISO3166_1Countries = (i18nMap) => {
  if (i18nMap.ISO3166_1 === 'ES') {
    return ['ES', 'AD'] // https://doveconviene.atlassian.net/browse/RPUB-717
  }

  return [i18nMap.ISO3166_1]
}

export const getGooglePlacesComponents = (i18nMap) => {
  return {
    country: getISO3166_1Countries(i18nMap),
  }
}

export function getWoosmapComponents(i18nMap) {
  return getISO3166_1Countries(i18nMap)
    .map(ISO3166_1 => `country:${ISO3166_1}`)
    .join('|')
}
